import { IonButton, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonRow, IonText } from "@ionic/react";
import { cardOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Fundraiser, User } from "../../models/data";
import { translation } from "../../models/translation";
import { fetchUserBalance_b } from "../../services/donate_service";
import { fetchSingleFundraiser } from "../../services/fundraise_service";

interface DonateToFundraiserStartProps {
    user: User
}

const DonateToFundraiserStart: React.FC<DonateToFundraiserStartProps> = ({ user }) => {

    const history = useHistory();


    const siteText=translation();
    
    const { id } = useParams<{ id: string; }>();

    const [state, setState] = useState<any>({});


 

    const [fundraiser, setFundraiser] = useState<Fundraiser | null>(null);

    const [amount, setAmount] = useState<number>(0);

    const [balance, setBalance] = useState<number>(0);

    useEffect(() => {
        let mounted = true;
        if (id === "open") {
            if (mounted) {
                setFundraiser(null)
            }
        } else {
            fetchSingleFundraiser(id).then(
                m => {
                    if (mounted) {
                        setFundraiser(m.message)
                    }
                }
            )
        }


        return () => {
            mounted = false
        }

    }, [fundraiser, id])



    useEffect(() => {
        let mounted = true;
        if (mounted) {
            fetchUserBalance_b(user.id).then(
                m => {
                    if (!m?.error) {
                        setBalance(m?.message)
                    }
                }
            )
        }
        return () => {
            mounted = false
        }

    }, [])

    const updateAmount = (value: string | any) => {
        setAmount(parseFloat(value))
    }

    useEffect(() => {
        if (state) {
            history.push(state.destination, state);
        }
    }, [state])


    /** */
    const onlinePayStart = (e: any) => {

        setState(() => {
            return {
                data: {
                    pickOrg: fundraiser ? fundraiser!.id : '',
                    amount: amount,
                    beneficiary_type: fundraiser ? "fundraiser" : '',
                    anom: "false",
                    freq: "single"

                },
                destination: fundraiser ? "../fundraiser_donate_online" : "../with_credit_to_org",
            }
        })

    }

    const creditAccount = (e: any) => {
        e.preventDefault();

        history.push("../credit");


    }
    /** */
    const creditPayStart = (destination: string) => {
        let data: any;
        if (amount < 1) return
        if (destination === "fundraiser") {
            data =
            {
                user: user,
                pickOrg: fundraiser!.id,
                amount: amount,
                beneficiary_type: "fundraiser",
                title: fundraiser!.title.rendered,
            }
        } else {
            data = {
                amount: amount,
                beneficiary_type: "organisation"
            }
        }

        setState(() => {
            return {
                data: data
                ,
                destination: `../with_credit_to_org`
            }
        })

    }

    return (
        <IonPage>
            <IonContent>
                <IonGrid>
                    {fundraiser &&
                        <IonRow>
                            <IonCol>
                                <IonRow>
                                    <IonCol size="12">
                                        <h1>
                                        {siteText.fundraiseDonateStartTitle.replace("%%title%%",fundraiser.title.rendered)}
                                        </h1>
                                        <p>
                                            {siteText.fundraiseDonateStartCreditIndication.replace("%%amount%%",''+balance)}
                                        </p>
                                    </IonCol>
                                    <IonCol>
                                        <IonLabel>{siteText.fundraiseDonateStartAmountLabel}</IonLabel>
                                        <IonItem lines="none" className="cashField" >
                                            <IonInput type="number" value={amount} min={0} onIonChange={e => updateAmount(e.detail.value)}></IonInput>
                                            <IonText className="ion-padding-start">
                                                CHF
                                            </IonText>
                                        </IonItem>
                                        <p>
                                            <IonText>
                                                {amount > balance ? siteText.donateUseCreditStartInsufficientCr : ''}
                                            </IonText>
                                        </p>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonButton fill={amount !== amount || amount <= balance ? "solid" : "outline"} disabled={!balance || amount === 0 || amount !== amount} onClick={e => { e.preventDefault(); amount <= balance ? creditPayStart("fundraiser") : creditAccount(e) }}>{amount <= balance ? siteText.fundraiseDonateStartPrimary : siteText.fundraiseDonateStartAlt}</IonButton>
                                        <IonButton disabled={!amount} color="secondary" onClick={e => onlinePayStart(e)}><IonText color="light">{siteText.fundraiseDonateStartSecondary}</IonText>  <IonIcon color="light" icon={cardOutline} ></IonIcon></IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonCol>
                        </IonRow>
                    }
                    {id === "open" &&
                        <IonRow>
                            <IonCol>
                                <IonRow>
                                    <IonCol size="12">
                                        <h1>{siteText.donateUseCreditStartTitle}</h1>
                                        <p>{siteText.donateUseCreditStartIndication.replace("%%amount%%",''+balance)}</p>
                                    </IonCol>
                                    <IonCol>
                                        <IonLabel>{siteText.donateUseCreditStartAmountLabel}</IonLabel>
                                        <IonItem lines="none" className="cashField" >
                                            <IonInput type="number" value={amount} min={0} onIonChange={e => updateAmount(e.detail.value)}></IonInput>
                                            <IonText className="ion-padding-start">
                                                CHF
                                            </IonText>
                                        </IonItem>
                                        <p>
                                            <IonText>
                                                {amount > balance ? siteText.donateUseCreditStartInsufficientCr : ''}
                                            </IonText>
                                        </p>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonButton fill={amount !== amount || amount <= balance ? "solid" : "outline"} disabled={!balance || amount === 0 || amount !== amount} onClick={e => { e.preventDefault(); amount <= balance ? creditPayStart("credit") : creditAccount(e) }}>{amount <= balance ? siteText.donateUseCreditStartPrimaryTxt : siteText.donateUseCreditAltTxt}</IonButton>
                                        <IonButton disabled={!amount} color="secondary" onClick={e => onlinePayStart(e)}><IonText color="light">{siteText.donateUseCreditStartSecondaryTxt}</IonText>  <IonIcon color="light" icon={cardOutline} ></IonIcon></IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonCol>
                        </IonRow>
                    }
                </IonGrid>
            </IonContent>
        </IonPage>
    )
}

export default DonateToFundraiserStart;